import { render } from "./ChengBenKu.vue?vue&type=template&id=3432b774"
import script from "./ChengBenKu.vue?vue&type=script&lang=js"
export * from "./ChengBenKu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__